export default {"src":"/_next/static/media/kids.ddede4f9.svg","height":30,"width":27,"blurWidth":0,"blurHeight":0};